module.exports = "/_next/static/images/1b1162bbf10250d91c53dbaaadb24085-title-icon.svg.webp";